export const statusArray = [{
    color: '#409eff',
    text: '已操作'
  },
  {
    color: '#f69b07',
    text: '异常待处理'
  },
  {
    color: '#f56c6c',
    text: '异常'
  },
  {
    color: '#5FABF2',
    text: '待操作'
  }
]
export const tableLabels = [{
    label: '',
    value: 'sampleType',
    minWidth: '120px'
  },
  {
    label: '样品数量',
    value: 'orderCount',
    minWidth: '120px'
  },
  {
    label: '样品名称',
    value: 'orderName',
    minWidth: '120px'
  },
  {
    label: '生产单位',
    value: 'productionUnit',
    minWidth: '120px'
  },
  {
    label: '商标',
    value: 'brand',
    minWidth: '120px'
  },
  {
    label: '规格/型号',
    value: 'specificationModel_text',
    minWidth: '120px'
  },
  {
    label: '颜色',
    value: 'color_text',
    minWidth: '120px'
  },
  {
    label: '形态',
    value: 'shape_text',
    minWidth: '120px'
  },
  {
    label: '包装',
    value: 'pack_text',
    minWidth: '120px'
  },

  {
    label: '存放条件',
    value: 'storage_text',
    minWidth: '150px'
  }
]
export let productTableLabels = [
  //   {
  //   label: '检测项目编号',
  //   value: 'itemVersion',
  //   minWidth: '120px'
  // },
  {
    label: '检测项目名称',
    value: 'itemName',
    minWidth: '120px'
  },
  {
    label: '检测依据',
    value: 'examBasis.name',
    minWidth: '120px'
  },
  {
    label: '检测周期',
    value: 'changeCycle',
    minWidth: '120px'
  },
  {
    label: '是否偏离',
    value: 'deviate_text',
    minWidth: '120px'
  },
  {
    label: '偏离原因',
    value: 'deviateInfo',
    minWidth: '120px'
  },
  {
    label: '相关文献',
    slotName: 'attachments',
    minWidth: '180px'
  },
  {
    label: '操作',
    slotName: 'operate',
    fixed: 'right',
    minWidth: '120px'
  }
]